import DialogConfirm from './DialogConfirm';

export default DialogConfirm;
